@if (initialized && dto) {

    <!-- ==================== Tab: Übersicht ==================== -->
    @if (activeNavigationItems?.action == 'overview') {
        <div class="p-3">
            <mvs-crud-object-generic
                [objectType]="'uf.UfFlowType'"
                [objectId]="objectIdentifier.objectId"
                (onChangedObject)="refreshObject(false)">
            </mvs-crud-object-generic>
        </div>
    }

    <!-- ==================== Tab: Felder ==================== -->
    @if (activeNavigationItems?.action == 'fields') {
        <div class="p-3">
            @if (fieldsWidget) {
                <mvs-widget [widgetData]="fieldsWidget"></mvs-widget>
            }
        </div>
    }

    <!-- ==================== Tab: Objektrollen ==================== -->
    @if (activeNavigationItems?.action == 'objectRoles') {
        <div class="p-3">
            @if (objectRolesWidget) {
                <mvs-widget [widgetData]="objectRolesWidget"></mvs-widget>
            }
        </div>
    }

    <!-- ==================== Tab: Schritte ==================== -->
    @if (activeNavigationItems?.action == 'steps') {
        <div class="p-3">
            @if (stepsWidget) {
                <mvs-widget [widgetData]="stepsWidget"></mvs-widget>
            }
        </div>
    }

}
